<template>
  <value-container v-if="view_only" :value="value" :label="label" :md="md"/>
  <v-flex :md3="md==3" :md4="md==4" v-else>
<!--     <b><fs1-span>{{label}}</fs1-span></b>
    <v-select
      :placeholder="value ? undefined : ' seleccionar'"
      v-model="model"
      :items="items"
      :item-text="item_text||'name'"
      :item-value="item_value||'id'"
      :disabled="disabled"
      :multiple="multiple"
      :class="multiple ? (value === null && 'textEmpty'): ((value === null || value.length === 0) && 'textEmpty')"/>

 -->

    <v-combobox
      clearable
      :label="label"
      :items="items"
      hide-details
      append-icon="search"
      :item-text="i_text"
      :item-value="i_value || i_text"
      chips
      small-chips
      deletable-chips
      hide-no-data
      multiple
      v-model="model"
      hide-selected/>
  </v-flex>
</template>
<script>
export default {
  props: ['label','value','md','disabled','items','item_value','item_text','multiple','view_only',  'template'/* si se usara en formulario o filtro u otro? */,'i_value', 'i_text'],
  data() {
    return { model:null }
  },
  watch: {
    'value'(v){ this.model=v },
    'model'(v){
			const  l = [];
			let f;
      const k = this.i_value || this.i_text;
			(v || []).forEach(n => {
				if (typeof n == 'object') {
					f = true;
					l.push(n[k])
				} else l.push(n)
			})
			if (f) this.model  = l;
      this.$emit('update:value', this.model)
    }
  },
  created(){ this.model=[undefined].includes(this.value)?null:this.value },
};
</script>
